var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.481,
    height: 19.333,
    viewBox: "0 0 21.481 19.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_email",
    d: "M282.045,280a5.431,5.431,0,0,1,5.436,5.424v8.485a5.432,5.432,0,0,1-5.436,5.424H271.435A5.431,5.431,0,0,1,266,293.909v-8.485A5.424,5.424,0,0,1,271.435,280Zm1.709,7.024.086-.086a.831.831,0,0,0-.012-1.074.9.9,0,0,0-.568-.279.816.816,0,0,0-.6.215l-4.843,3.867a1.683,1.683,0,0,1-2.148,0l-4.833-3.867a.821.821,0,0,0-1.15,1.149l.141.14,4.887,3.813a3.382,3.382,0,0,0,4.2,0Z",
    transform: "translate(-266 -280)",
    fill: "#797979",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.14dbc448ee1d96f0a1a8c064c1018868.svg";
export { ForwardRef as ReactComponent };